// A 1-5 digit integer with no leading zero, literal 'x', another such integer — the exact
// shape used by every hardcoded creative dimension option (e.g. '320x100'). No zero-sized
// dimension, no internal whitespace, no uppercase 'X'.
const DIMENSION_PATTERN = /^[1-9]\d{0,4}x[1-9]\d{0,4}$/;

export const isValidDimension = (value: string): boolean => DIMENSION_PATTERN.test(value.trim());

export const invalidDimensionMessage = (value: string): string =>
  `"${value.trim()}" must be in the format <width>x<height> (e.g. "320x100").`;
